import './googleAutocomplete.scss';

export const GoogleAutoComplete = angular
    .module('app.components.googleAutocomplete', [])
    .component('googleAutocomplete', {
        template: '<ng-transclude></ng-transclude>',
        bindings: {
            model: '=',
            formController: '=',
            country: '<',
            autocompleteCountries: '<'
        },
        transclude: true,
        controller: class GoogleAutocompleteCtrl {
            constructor($window, $timeout, $rootScope, $element) {
                angular.extend(this, {
                    $window,
                    $timeout,
                    $rootScope,
                    $element
                });
            }

            $onInit() {
                this.$timeout(() => {
                    this.initGoogleAutocomplete();
                });
            }

            $onChanges(changesObj) {
                if (changesObj && changesObj.country && !changesObj.country.isFirstChange()) {
                    if (this.autocompleteCountries.includes(changesObj.country.currentValue)) {
                        this.setAutoCompleteVisible(true);
                        this.setCountryRestriction(changesObj.country.currentValue);
                    } else {
                        this.setAutoCompleteVisible(false);
                    }
                }
            }

            setAutoCompleteVisible(visibility) {
                angular.element(this.$window.document.body).toggleClass('google-autocomplete-hidden', !visibility);
            }

            initGoogleAutocomplete() {
                this.autocomplete = new this.$window.google.maps.places.Autocomplete(
                    this.$element[0].querySelector('input[google-maps-autocomplete-input]'),
                    {
                        types: ['address']
                    }
                );
                if (this.model && this.model.country) {
                    this.setCountryRestriction(this.model.country);
                }
                this.autocomplete.addListener('place_changed', this.onPlaceChanged.bind(this));
            }

            clearAddress() {
                this.model.address1 = '';
                this.model.address2 = '';
                this.model.city = '';
                this.model.state = '';
                this.model.country = '';
                this.model.postalCode = '';
                this.formController.$setUntouched();
                this.$rootScope.$apply();
            }

            setGoogleAddressToModel(addressFromGoogle) {
                if (addressFromGoogle.street_number && addressFromGoogle.route) {
                    this.model.address1 = `${addressFromGoogle.street_number} ${addressFromGoogle.route}`;
                } else if (addressFromGoogle.route) {
                    this.model.address1 = addressFromGoogle.route;
                }

                this.model.city = addressFromGoogle.locality ||
                    addressFromGoogle.neighborhood || addressFromGoogle.administrative_area_level_2;
                this.model.state = addressFromGoogle.administrative_area_level_1;
                this.model.country = addressFromGoogle.country;
                this.model.postalCode = addressFromGoogle.postal_code;
            }

            getFlattenedAddressObject(place) {
                const addressFromGoogle = {};
                angular.forEach(place.address_components, (addressComponent) => {
                    const componentType = addressComponent.types[0];
                    addressFromGoogle[componentType] = addressComponent.short_name;
                });
                return addressFromGoogle;
            }

            onPlaceChanged() {
                const place = this.autocomplete.getPlace();
                if (place.address_components.length > 0) {
                    this.clearAddress();
                    this.setGoogleAddressToModel(this.getFlattenedAddressObject(place));
                    this.$rootScope.$apply();
                }
            }

            setCountryRestriction(setCountry) {
                this.autocomplete.setComponentRestrictions({ country: setCountry });
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/googleAutocomplete/googleAutocomplete.js